export default __webpack_public_path__ + "images/72b03d97a60f864e738b6732b9bfc576.svg";